// utils/voucherFilters.js

/**
 * Apply filters to any list of vouchers
 * This function doesn't care if they're gifting or regular vouchers
 */
export const applyFilters = (vouchers, filters) => {
    let filtered = vouchers;

    // Filter by cinema groups
    if (filters.cinemaGroups?.length > 0) {
        filtered = filtered.filter((voucher) =>
            voucher?.cinema_group_name && filters.cinemaGroups.includes(voucher.cinema_group_name)
        );
    }

    // Filter by ticket classes
    if (filters.ticketClasses?.length > 0) {
        filtered = filtered.filter((voucher) =>
            voucher?.ticket_class_name &&
            filters.ticketClasses.includes(voucher.ticket_class_name)
        );
    }

    // Filter by ticket types
    if (filters.ticketTypes?.length > 0) {
        filtered = filtered.filter((voucher) =>
            voucher?.ticket_type_name &&
            filters.ticketTypes.includes(voucher.ticket_type_name)
        );
    }

    return filtered;
};


const generateUniqueOptions = (voucherList, extractFn) => {
    if (!voucherList?.length) return [];

    const uniqueMap = new Map();
    voucherList.forEach((voucher) => {
        const result = extractFn(voucher);
        if (result) {
            uniqueMap.set(result.value, result);
        }
    });
    return [...uniqueMap.values()];
};


export const generateFilterOptions = (voucherList) => ({
    cinemaGroups: generateUniqueOptions(voucherList, (voucher) =>
        voucher?.cinema_group_name ? {
            label: voucher.cinema_group_name,
            value: voucher.cinema_group_name,
        } : null
    ),
    ticketClasses: generateUniqueOptions(voucherList, (voucher) =>
        voucher?.ticket_class_name ? {
            label: voucher.ticket_class_name,
            value: voucher.ticket_class_name,
        } : null
    ),
    ticketTypes: generateUniqueOptions(voucherList, (voucher) =>
        voucher?.ticket_type_name ? {
            label: voucher.ticket_type_name,
            value: voucher.ticket_type_name,
        } : null
    ),
});
